export default __webpack_public_path__ + "static/media/Snapshot.3dfa806e.svg";